import { safeLocalStorage } from "client_legacy/ndaw/safeStorage";
const MAX_SIZE = 5;

export function listEnvironments(): readonly string[] {
	return load();
}

export function addEnvironment(environmentName: string) {
	const environments: string[] = load()
		.filter(x => x !== environmentName);

	environments.unshift(environmentName);

	persist(environments.slice(0, MAX_SIZE));
}

export function removeEnvironment(environmentName: string): void {
	const environments: string[] = load()
		.filter(x => x !== environmentName);
	persist(environments);
}

function load(): string[] {
	return safeLocalStorage.getItem<string[]>("recentEnvironments") || [];
}

function persist(environments: readonly string[]): void {
	safeLocalStorage.setItem("recentEnvironments", environments);
}
